export const APP_NAME = 'Lya Health';
export const PERSIST_STORE_NAME = 'lyahealth';
export const REDIRECT_URL_KEY = 'redirectUrl';
